import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import Close from '@/assets/images/deviceTesting/close.png';
import AudioDetector from './AudioDetector';
import MicDetector from './MicDetector';
import './style';

class DeviceTesting extends React.PureComponent {
  static propTypes = {
    hide: PropTypes.func,
    cloneName: PropTypes.string,
  };

  state = {
    isMic: false,
  };

  componentDidMount() {
  }

  handleHideModal = (e) => {
    e.preventDefault();
    this.props.hide();
  };

  handleChange = (e) => {
    e.preventDefault();
    const { isMic } = this.state;
    this.setState({ isMic: !isMic });
  };

  render() {
    const { isMic } = this.state;
    return (
      <PopUp cloneName={this.props.cloneName} hide={this.handleHideModal}>
        <div className="modal-box">
          <div className="box">
            <div className="box-section-top">
              <div className="close-box-btn" id="close" onClick={(e) => { this.handleHideModal(e); }}>
                <img src={Close} alt="" />
              </div>
              <ul className="device-ul">
                <li>
                  <div className="audio" />
                  <div className={`li-txt${isMic ? '' : ' click'}`} onClick={this.handleChange}>耳机</div>
                </li>
                <li>
                  <div className="mic" />
                  <div className={`li-txt${isMic ? ' click' : ''}`} onClick={this.handleChange}>麦克风</div>
                </li>
              </ul>
              {
                isMic && <MicDetector />
              }
              {
                !isMic && <AudioDetector />
              }
            </div>
          </div>
        </div>
      </PopUp>
    );
  }
}

export default DeviceTesting;
